<template>
    <nav class="c-main-nav"
        :data-component-name="$options.name"
    >
        <ul class="c-main-nav-list" :class="{'is-hover': isTooltipActive}" @mouseover="showTooltip" @mouseleave="hideTooltip">
            <!-- <li class="c-main-nav-list__item">
                <router-link 
                    :to="{ name: 'index'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'dashboard' }"
                >
                    <SvgIcon name="dashboard" />
                    <span class="c-main-nav__link__text">Tableau de bord</span>
                </router-link>
            </li> -->
            <li class="c-main-nav-list__item -hidden-mobile" data-miniNavTooltip="Projets" v-if="checkRules('projects')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'projects'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'projects' }"
                >
                    <SvgIcon name="project2" />
                    <span class="c-main-nav__link__text">Projets</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item" data-miniNavTooltip="Employés" v-if="checkRules('staffs')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'staffs'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'staffs' }"
                >
                    <SvgIcon name="staff" />
                    <span class="c-main-nav__link__text">Employés</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item" data-miniNavTooltip="Employés" v-if="checkRules('resources') && $generalSettings.settings.enableResourceModule" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'resources'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'resources' }"
                >
                    <SvgIcon name="staff" />
                    <span class="c-main-nav__link__text">Ressources</span>
                </router-link>
            </li>
            <!-- <li class="c-main-nav-list__item" data-miniNavTooltip="Ouvrir" v-if="checkRules('resources')">
                <router-link 
                    :to="{ name: 'resources'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'resources' }"
                >
                    <SvgIcon name="industry" />
                    <span class="c-main-nav__link__text">Ressources</span>
                </router-link>
            </li> -->
            <!--<li class="c-main-nav-list__item">
                <router-link 
                    :to="{ name: 'customers'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'customers' }"
                >
                    <SvgIcon name="industry" />
                    <span class="c-main-nav__link__text">Clients</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item">
                <router-link 
                    :to="{ name: 'vehicules'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'vehicules' }"
                >
                    <SvgIcon name="vehicule" />
                    <span class="c-main-nav__link__text">Véhicules</span>
                </router-link>
            </li> -->
            <li class="c-main-nav-list__item" data-miniNavTooltip="Affectations" v-if="checkRules('pendings')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'pendings'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'pendings' }"
                >
                    <SvgIcon name="pending" />
                    <span class="c-main-nav__link__text">
                        Affectations
                        <q-badge class="-badge" rounded align="middle" :label="pendingAssignmentsCount" v-if="pendingAssignmentsCount>0"></q-badge>
                    </span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item" data-miniNavTooltip="Boite de réception" v-if="checkRules('messages')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'messages'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'inbox' || currentRoute == 'sent' }"
                >
                    <SvgIcon name="inbox" />
                    <span class="c-main-nav__link__text">Boite de réception</span>
                </router-link>
            </li>
            <!-- <li class="c-main-nav-list__item" data-miniNavTooltip="Ouvrir" v-if="checkRules('assignments')">
                <router-link 
                    :to="{ name: 'assignments'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'assignments' }"
                >
                    <SvgIcon name="inbox" />
                    <span class="c-main-nav__link__text">Affectations OLD</span>
                </router-link>
            </li> -->
            <!-- <li class="c-main-nav-list__item">
                <router-link 
                    :to="{ name: 'inbox'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'inbox' }"
                >
                    <SvgIcon name="inbox" />
                    <span class="c-main-nav__link__text">Inbox</span>
                </router-link>
            </li> -->
            <li class="c-main-nav-list__item" data-miniNavTooltip="Mon horaire" v-if="checkRules('schedule')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'schedule'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'schedule' }"
                >
                    <SvgIcon name="schedule" />
                    <span class="c-main-nav__link__text">Mon horaire</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item -hidden-mobile" data-miniNavTooltip="Rapport de temps" v-if="checkRules('timereport')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <div
                    class="c-main-nav__link"
                    @click="$eventBus.$emit('toggle-timereport-panel')"
                >
                    <SvgIcon name="clock" />
                    <span class="c-main-nav__link__text">Rapport de temps</span>
                </div>
            </li>
            <li class="c-main-nav-list__item -hidden-desktop" data-miniNavTooltip="Rapport de temps" v-if="checkRules('timereport')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'timereport'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'timereport' }"
                >
                    <SvgIcon name="clock" />
                    <span class="c-main-nav__link__text">Rapport de temps</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item -hidden-mobile" data-miniNavTooltip="Feuilles de temps" v-if="checkRules('timesheet') && 1==2" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <div
                    class="c-main-nav__link"
                    @click="$eventBus.$emit('toggle-timesheet-panel')"
                >
                    <SvgIcon name="clock" />
                    <span class="c-main-nav__link__text">Feuilles de temps</span>
                </div>
            </li>
            <li class="c-main-nav-list__item -hidden-desktop" data-miniNavTooltip="Feuilles de temps" v-if="checkRules('timesheet') && 1==2" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'timesheet'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'timesheet' }"
                >
                    <SvgIcon name="clock" />
                    <span class="c-main-nav__link__text">Feuilles de temps</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item -hidden-mobile" data-miniNavTooltip="Temps d'équipe" v-if="checkRules('timesheetforeman')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <div
                    class="c-main-nav__link"
                    @click="$eventBus.$emit('toggle-timesheet-foreman-panel')"
                >
                    <SvgIcon name="clock" />
                    <span class="c-main-nav__link__text">Temps d'équipe</span>
                </div>
            </li>
            <li class="c-main-nav-list__item -hidden-desktop" data-miniNavTooltip="Temps d'équipe" v-if="checkRules('timesheetforeman')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'timesheetforeman'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'timesheetforeman' }"
                >
                    <SvgIcon name="clock" />
                    <span class="c-main-nav__link__text">Temps d'équipe</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item -border-top -hidden-mobile" data-miniNavTooltip="Paramètres" v-if="checkRules('settings') && myProfile.role != 'STAFF' && myProfile.role != 'FOREMAN'" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'settings'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'settings' }"
                >
                    <SvgIcon name="setting" />
                    <span class="c-main-nav__link__text">Paramètres</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item -border-top" data-miniNavTooltip="Mon compte" v-if="checkRules('my-profile') && ((myProfile.role!='ADMINISTRATOR' && myProfile.role!='MANAGER') || isMobile)" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'my-account'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': $route.name == 'my-account' }"
                >
                    <SvgIcon name="user" />
                    <span class="c-main-nav__link__text">Mon compte</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item" data-miniNavTooltip="Mon profile" v-if="checkRules('my-profile') && ((myProfile.role!='ADMINISTRATOR' && myProfile.role!='MANAGER') || isMobile)" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'my-profile'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': $route.name == 'my-profile' }"
                >
                    <SvgIcon name="account" />
                    <span class="c-main-nav__link__text">Mon profil</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item" data-miniNavTooltip="Aide" v-if="checkRules('help')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'help'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'help' }"
                >
                    <SvgIcon name="alert" />
                    <span class="c-main-nav__link__text">Aide</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item -border-top" data-miniNavTooltip="Me déconnecter" v-if="checkRules('logout')" onclick="this.closest('.c-app').classList.remove('is-mobile-nav-active');">
                <router-link 
                    :to="{ name: 'logout'}"
                    class="c-main-nav__link"
                    :class="{ 'is-current': currentRoute == 'logout' }"
                >
                    <SvgIcon name="power" />
                    <span class="c-main-nav__link__text">Me déconnecter</span>
                </router-link>
            </li>
            <li class="c-main-nav-list__item c-main-nav__toggle -border-top -hidden-mobile" data-miniNavTooltip="Ouvrir">
                <div class="c-main-nav__link" onclick="this.closest('.c-app').classList.toggle('is-nav-mini');">
                    <SvgIcon name="arrow-alt-left" />
                    <span class="c-main-nav__link__text">Réduire</span>
                </div>
            </li>
        </ul>
        
    </nav>
</template>

<script>
    import { checkRouterRules } from '@/js/utilities'
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'LeftNav',
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
        },
        data(){
            return {
                pendingAssignmentsCount: 0,
                isNavMini: false,
                isTooltipActive: false,
                isNavHovering: false,
                tooltipDelay: null
            }
        },
        computed: {
            // console: () => console,
            // window: () => window,
            currentRoute: function(){
                if(this.$route.path.split('/')[1]=="settings") return "settings";
                return this.$route.name;
            }
        },
        mounted() {
            this.pendingAssignmentsCount=window.pendingAssignmentsCount;
            this.$eventBus.$on('set-notifs-count', function(e){
                this.pendingAssignmentsCount=e.pendingAssignmentsCount;
            }.bind(this))
        },
        methods: {
            // debug(event) {
            //     console.log(event)
            // },
            checkRules(routeName){
                return checkRouterRules(routeName, this.$router)
            },
            showTooltip() {
                if(this.isNavHovering===false && this.$parent.$el.classList.contains('is-nav-mini')){
                    clearTimeout(this.tooltipDelay);
                    this.isNavHovering = true;
                    this.tooltipDelay = setTimeout(() => this.isTooltipActive = this.isNavHovering, 2500);
                }
            },
            hideTooltip() {
                this.isNavHovering = false;
                this.isTooltipActive = false;
            }
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
        }
    }

</script>

<style scoped lang="scss">
    @import "@/scss/components/nav/LeftNav.scss";
</style>
